const menuOverlayTrigger = document.querySelectorAll('.js-menu-button');
const menuOverlay = document.querySelector(".js-menu-overlay");

let isActive = false;

  //open menu overlay timeline
  const openMenuOverlayTl = gsap.timeline({ paused: true });
  openMenuOverlayTl
      .to(menuOverlay, 0.3, {
          autoAlpha: 1,
          ease: Power1.easeInOut
      });
  //close menu overlay timeline
  const closeMenuOverlayTl = gsap.timeline({ paused: true });
  closeMenuOverlayTl
      .to(menuOverlay, 0.3, {
          autoAlpha: 0,
          ease: Power1.easeInOut
      });

  //bind events
  menuOverlayTrigger.forEach((btn) => {
    btn.addEventListener("click", (e) => {
        e.preventDefault();

        if (!isActive) {
            menuOverlayTrigger[0].classList.add("is-active");
            menuOverlay.classList.add("is-active");
            body.classList.add("stop-scrolling");
            openMenuOverlayAnimations(openMenuOverlayTl, closeMenuOverlayTl, btn);
        } else {
            closeMenuOverlayAnimations(openMenuOverlayTl, closeMenuOverlayTl, btn);
            body.classList.remove("stop-scrolling");
            menuOverlay.classList.remove("is-active");
            btn.classList.remove("is-active");
        }

        isActive = !isActive;
    });
});

//functions
function openMenuOverlayAnimations(openMenuOverlayTl, closeMenuOverlayTl, btn) {
    closeMenuOverlayTl.pause();
    openMenuOverlayTl.restart();
}

function closeMenuOverlayAnimations(openMenuOverlayTl, closeMenuOverlayTl, btn) {
    openMenuOverlayTl.pause();
    closeMenuOverlayTl.restart();
}

function overlayLinks() {
    
    const desktopMenuBtns = document.querySelectorAll('.js-menu-btn'),
        desktopMenuTl = gsap.timeline();

    desktopMenuBtns.forEach((btn) => {

        btn.addEventListener('click', () => {

            body.classList.remove("stop-scrolling");
            menuOverlay.classList.remove("is-active");
            menuOverlayTrigger[0].classList.remove("is-active");
            isActive = !isActive;

            const assocChap = document.querySelector(
                `.js-chapter-section-${parseInt(btn.dataset.num)}`
            );

            desktopMenuTl.to(menuOverlay, 0.3, {
                autoAlpha: 0,
                ease: Power1.easeInOut
            });

            desktopMenuTl.to(window, {
                duration: 0.6,
                ease: "power4.easeInOut",
                scrollTo: assocChap
            });
        })
    })
}